import DBTable from "../../../../../component/global/DBTable/DBTable";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";

const headers = [
  {
    id: 'row',
    title: 'ردیف',
    gridTemplateColumns: '55px'
  },
  {
    id: 'dateAndTime',
    title: 'تاریخ و ساعت',
    gridTemplateColumns: '90px'
  },
  {
    id: 'description',
    title: 'شرح',
    gridTemplateColumns: '1fr'
  },
  {
    id: 'price',
    title: 'مبلغ',
    gridTemplateColumns: '88px',
    numberWithComma: true,
  },
  {
    id: 'stock',
    title: 'موجودی',
    gridTemplateColumns: '88px',
    numberWithComma: true,
  },
]

const rows = [
  {
    row: '1',
    dateAndTime: '1401/06/12 \n 20:18',
    description: 'توضیحات حساب',
    price: '500000',
    stock: '2500000',
  },
  {
    row: '2',
    dateAndTime: '1401/06/12 \n 20:18',
    description: 'توضیحات حساب',
    price: '500000',
    stock: '2500000',
  },
  {
    row: '3',
    dateAndTime: '1401/06/12 \n 20:18',
    description: 'توضیحات حساب',
    price: '500000',
    stock: '2500000',
  },
]

function TransactionRecords() {
  const {t} = useTranslation()
  const headers = useMemo(()=>{
    return [
      {
        id: 'row',
        title: t('Organizational.Profile.Packages.Report.Transaction.Table.Row'),
        gridTemplateColumns: '55px'
      },
      {
        id: 'dateAndTime',
        title: t('Organizational.Profile.Packages.Report.Transaction.Table.DateAndTime'),
        gridTemplateColumns: '90px'
      },
      {
        id: 'description',
        title: t('Organizational.Profile.Packages.Report.Transaction.Table.Description'),
        gridTemplateColumns: '1fr'
      },
      {
        id: 'price',
        title: t('Organizational.Profile.Packages.Report.Transaction.Table.Price'),
        gridTemplateColumns: '88px',
        numberWithComma: true,
      },
      {
        id: 'stock',
        title: t('Organizational.Profile.Packages.Report.Transaction.Table.Stock'),
        gridTemplateColumns: '88px',
        numberWithComma: true,
      },
    ]
  },[t])

  return (
    <div>
      <DBTable width={700} headers={headers} rows={rows}/>
    </div>
  );
}

export default TransactionRecords;
